/*@flow*/
import * as I from 'immutable';

export default function addFooWhenTypesEmpty(filter: {}): any {
  // Add all section names when types are empty.
  const updateType = (v = I.List()) => {
    if (v.size > 0) return v;
    return v.concat(['foo']);
  };

  return I.fromJS(filter || {}).update('type', updateType);
}
